/** Base URL for canonical links, Open Graph, and JSON-LD. */
export const SITE_URL = "https://www.basementbikemechanic.com";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const DEFAULT_TITLE =
  "Bike Repair Atlanta | Tune-Ups & Bicycle Service | Basement Bike Mechanic";

export const DEFAULT_DESCRIPTION =
  "Shop-based Atlanta bike repair and tune-ups by appointment. Drop off at 2272 Melinda Dr NE. All work done at my basement workshop; no on-site mobile repairs. Text or book online.";
